const POSITIONS = {
  "Goal Shooter": "GS",
  "Goal Attack": "GA",
  "Wing Attack": "WA",
  Centre: "C",
  "Wing Defence": "WD",
  "Goal Defence": "GD",
  "Goal Keeper": "GK",
};

const POSITIONS_SORT = {
  "Goal Shooter": 7,
  "Goal Attack": 6,
  "Wing Attack": 5,
  Centre: 4,
  "Wing Defence": 3,
  "Goal Defence": 2,
  "Goal Keeper": 1,
};

export class Formation {
  constructor({ animate, preview, update, animateOff }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.name = "Formation";
    this.scene = "Formation";
    this.data = [];
  }

  async preview({ options }) {
    this.onAir = false;
    let lineup = [];
    let stats = [];
    debugger;
    if (options.game?.home_team._id === options.team._id) {
      lineup = options.game?.lineup?.home;
      stats = options.game?.home_player_stats;
    } else if (options.game?.away_team._id === options.team._id) {
      lineup = options.game?.lineup?.away;
      stats = options.game?.away_player_stats;
    }
    this.data = [];

    // Surname or Intials helper function
    const allLastNames = lineup.map((p) => p?.squad?.player?.last_name) || [];

    const getCheckedName = (player) => {
      const lastName = player?.squad?.player?.last_name || "";
      const firstName = player?.squad?.player?.first_name || "";
      const isDuplicate = allLastNames.filter((name) => name === lastName).length > 1;
      return isDuplicate ? `${firstName[0]}. ${lastName}` : lastName;
    }
    

    this.data.push({
      name: "Competition",
      value: { text: options.game?.competition?.name || "" },
    });
    this.data.push({
      name: "Competition Colour",
      value: { colour: options.game?.competition?.colour || "" },
    });
    this.data.push({
      name: "Competition Badge",
      value: { image: "${user}" + options.game?.competition?.badge || "" },
    });

    this.data.push({
      name: "Manager First Name",
      value: {
        text: options?.manager?.player?.first_name,
      },
    });
    this.data.push({
      name: "Manager First Name Uppercase",
      value: {
        text: options?.manager?.player?.first_name_upper,
      },
    });
    this.data.push({
      name: "Manager Last Name",
      value: {
        text: options?.manager?.player?.last_name,
      },
    });
    this.data.push({
      name: "Manager Last Name Uppercase",
      value: {
        text: options?.manager?.player?.last_name_upper,
      },
    });

    this.data.push({
      name: "Manager Full Name",
      value: {
        text:
          options?.manager?.player?.first_name +
          " " +
          options?.manager?.player?.last_name,
      },
    });
    this.data.push({
      name: "Manager Full Name Uppercase",
      value: {
        text:
          options?.manager?.player?.first_name_upper +
          " " +
          options?.manager?.player?.last_name_upper,
      },
    });
    this.data.push({
      name: "Manager Title",
      value: {
        text: options?.manager?.player?.title,
      },
    });

    this.data.push({
      name: "Team Badge",
      value: {
        image: "${user}" + options.team?.variables?.hyper_badge || "",
      },
    });
    this.data.push({
      name: "Team Secondary Badge",
      value: {
        image: "${user}" + options.team?.variables?.alt_badge || "",
      },
    });
    this.data.push({
      name: "Team Third Badge",
      value: {
        image: "${user}" + options.team?.variables?.third_badge || "",
      },
    });
    this.data.push({
      name: "Team Name",
      value: {
        text: options.team?.name || "",
      },
    });

    let kit =
      options.team?._id === options.game?.home_team?._id
        ? options.game?.home_team_kit
        : options.game?.away_team_kit;

    this.data.push({
      name: "Team Kit BG Colour",
      value: {
        colour: options.team?.variables?.[kit + "_kit_bg"] || "",
      },
    });
    this.data.push({
      name: "Team Kit Text Colour",
      value: {
        colour: options.team?.variables?.[kit + "_kit_text"] || "",
      },
    });

    this.data.push({
      name: "Team Kit BG Colour String",
      value: {
        text: options.team?.variables?.[kit + "_kit_bg"] || "",
      },
    });
    this.data.push({
      name: "Team Kit Text Colour String",
      value: {
        text: options.team?.variables?.[kit + "_kit_text"] || "",
      },
    });
    this.data.push({
      name: "Team Kit Image",
      value: {
        image:
          "${user}" +
            options.team?.variables?.["hyper_" + kit + "_kit_image"] || "",
      },
    });

    this.data.push({
      name: "Kit Variable",
      value: {text: options.formationtoggle},
    })

    lineup
      ?.filter((p) => p.order <= 7)
      ?.sort((a, b) => {
        let stat_a = stats?.find((p) => p.squad_id === a?.squad?._id);
        let stat_b = stats?.find((p) => p.squad_id === b?.squad?._id);
        return (
          POSITIONS_SORT[stat_a?.position] - POSITIONS_SORT[stat_b?.position]
        );
      })
      .forEach((player, index) => {
        let row = "0" + (index + 1);

        let stat = stats?.find((p) => p.squad_id === player?.squad?._id);
        try {
          this.data.push({
            name: "Position " + (index + 1),
            value: {
              text: POSITIONS[stat?.position] || "",
            },
          });

          this.data.push({
            name: "First Name " + (index + 1),
            value: {
              text: player?.squad?.player?.first_name,
            },
          });
          this.data.push({
            name: "First Name Uppercase " + (index + 1),
            value: {
              text: player?.squad?.player?.first_name_upper,
            },
          });

          this.data.push({
            name: "Last Name " + (index + 1),
            value: {
              text: getCheckedName(player),
            },
          });
          this.data.push({
            name: "Last Name Uppercase " + (index + 1),
            value: {
              text: player?.squad?.player?.last_name_upper,
            },
          });
          this.data.push({
            name: "Full Name " + (index + 1),
            value: {
              text:
                player?.squad?.player?.first_name +
                " " +
                player?.squad?.player?.last_name,
            },
          });
          this.data.push({
            name: "Full Name Uppercase " + (index + 1),
            value: {
              text:
                player?.squad?.player?.first_name_upper +
                " " +
                player?.squad?.player?.last_name_upper,
            },
          });
        } catch (err) {}
      });

    new Array(7).fill(1)?.forEach((_, index) => {
      let player = lineup?.find((p) => p.order === index + 8);
      let row = index + 8;
      let stat = stats?.find((p) => p.squad_id === player?.squad?._id);
      try {
        this.data.push({
          name: "Position " + row,
          value: {
            text: POSITIONS[stat?.position] || "",
          },
        });

        this.data.push({
          name: "First Name " + row,
          value: {
            text: player?.squad?.player?.first_name ?? "",
          },
        });
        this.data.push({
          name: "First Name Uppercase " + row,
          value: {
            text: player?.squad?.player?.first_name_upper ?? "",
          },
        });

        this.data.push({
          name: "Last Name " + row,
          value: {
            text: getCheckedName(player) ?? "",
          },
        });
        this.data.push({
          name: "Last Name Uppercase " + row,
          value: {
            text: player?.squad?.player?.last_name_upper ?? "",
          },
        });
        this.data.push({
          name: "Full Name " + row,
          value: {
            text:
              (player?.squad?.player?.first_name ?? "") +
              " " +
              (player?.squad?.player?.last_name ?? ""),
          },
        });
        this.data.push({
          name: "Full Name Uppercase " + row,
          value: {
            text:
              (player?.squad?.player?.first_name_upper ?? "") +
              " " +
              (player?.squad?.player?.last_name_upper ?? ""),
          },
        });
      } catch (err) {}
    });
    this.sendPreview(this.scene, 500, this.data, "IN");
  }
  animate({ options }) {
    this.onAir = true;
    this.sendAnimate(this.scene, this.data);
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff(this.scene, []);
  }
}
